import React from 'react'
import moment from 'moment'
import { TableProps } from 'antd/lib/table'

import { ColumnProps } from 'src/components/Ant/Table'
import { Table, Text } from 'src/components/Ant'
import { R4Data } from 'src/store/ducks/reports/types'
const Spacer = <span />
const columns: ColumnProps<R4Data>[] = [
  {
    align: 'center',
    dataIndex: 'request_number',
    key: 'request_number',
    render: (value: string) => <Text>#{value}</Text>,
    title: 'web.report.4.data.request_number',
    width: 35
  },
  {
    align: 'center',
    dataIndex: 'request_date',
    key: 'request_date',
    render: (value: number) => (
      <Text>{moment.unix(value).format('DD/MM/YYYY')}</Text>
    ),
    title: 'web.report.4.data.request_date',
    width: 60
  },
  {
    dataIndex: 'description',
    ellipsis: true,
    key: 'description',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.4.data.description'
  },
  {
    dataIndex: 'travelerReason',
    ellipsis: true,
    key: 'travelerReason',
    render: (_: unknown, { traveler }) => {
      return (
        <Text>
          {traveler.map(({ reason }, index) => (
            <React.Fragment key={index}>
              {index > 0 ? (
                <>
                  <br />
                  {Spacer}
                </>
              ) : (
                ''
              )}
              {reason}
            </React.Fragment>
          ))}
        </Text>
      )
    },
    title: 'web.report.4.data.reason',
    width: 90
  },
  {
    dataIndex: 'traveler',
    ellipsis: true,
    key: 'traveler',
    render: (_: unknown, { traveler }) => {
      return (
        <Text>
          {traveler.map(({ name }, index) => (
            <React.Fragment key={index}>
              {index > 0 ? <br /> : ''}
              {name}
            </React.Fragment>
          ))}
        </Text>
      )
    },
    title: 'web.report.4.data.traveler',
    width: 90
  },
  {
    align: 'center',
    dataIndex: 'travelerPendent',
    key: 'travelerPendent',
    render: (_: unknown, { status, traveler }) =>
      status === 'UNDERWAY' ? (
        ''
      ) : (
        <>
          {traveler.map(({ update_on }, index) => (
            <Text key={index}>
              {index > 0 ? <br /> : ''}
              {moment().diff(moment.unix(update_on).utc(), 'days')}
            </Text>
          ))}
        </>
      ),

    title: 'web.report.4.data.pendent',
    width: 75
  },
  {
    dataIndex: 'travelerStatus',
    key: 'travelerStatus',
    render: (_: unknown, { traveler }) => {
      return (
        <Text>
          {traveler.map(({ status }, index) => (
            <React.Fragment key={index}>
              {index > 0 ? <br /> : ''}
              <Text
                title={`common.status.unified.${status.toLocaleLowerCase()}`}
              />
            </React.Fragment>
          ))}
        </Text>
      )
    },
    title: 'web.report.4.data.status'
  },
  {
    dataIndex: 'owner',
    key: 'owner',
    render: owner => {
      return (
        <Text>
          {owner.map((name: string, index: number) => (
            <React.Fragment key={index}>
              {index > 0 ? <br /> : ''}
              {name}
            </React.Fragment>
          ))}
        </Text>
      )
    },
    title: 'web.report.4.data.owner'
  }
]

function TableDetail({ ...props }: TableProps<R4Data>) {
  return (
    <Table
      {...props}
      className="table-striped table-sm"
      columns={columns}
      pagination={false}
    />
  )
}

export default TableDetail
